import React from 'react';
import { Image, Tooltip } from 'antd';
import { TriangleAlert, ImageOff } from 'lucide-react';
import { StatusTag } from '../../common';
import { SOURCE_LABELS, SOURCE_TONES } from '../levantamientoShared';

/** Source pill: Mary / Auditoría / Competencia. */
export function SourceTag({ source }) {
    return <StatusTag tone={SOURCE_TONES[source] || 'neutral'}>{SOURCE_LABELS[source] || source}</StatusTag>;
}

/** Capture photo thumbnail (click to preview) or a quiet placeholder. */
export const ProductThumb = ({ src }) =>
    src ? (
        <Image src={src} alt="" width={40} height={40} className="rounded-lg object-cover" preview={{ mask: null }} />
    ) : (
        <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-surface-50 text-surface-300">
            <ImageOff className="text-sm" />
        </span>
    );

/** USD price, right-aligned; atípicos get a warning flag with an explanatory tooltip. */
export function CapturePrice({ value, isOutlier, title }) {
    if (value == null) return <span className="text-surface-400">—</span>;
    const price = `$${Number(value).toFixed(2)}`;
    if (!isOutlier) return <span className="font-medium tabular-nums text-surface-900">{price}</span>;
    return (
        <Tooltip title={title}>
            <span className="inline-flex items-center justify-end gap-1.5 font-medium tabular-nums text-warning-fg">
                <TriangleAlert className="text-[13px]" />
                {price}
            </span>
        </Tooltip>
    );
}

/** Role / user type as a neutral pill. */
export function RoleTag({ role }) {
    return role ? <StatusTag>{role}</StatusTag> : <span className="text-surface-400">—</span>;
}
